import Axios from 'axios'
import interceptors from './Interceptors'

const TOKEN_MIN_VALIDITY_BEFORE_REFRESH = 3 * 60 * 1000; // 3 mins

const ApiHttp = Axios.create();

// interceptors is responsible, mainly, for handling token generation in the system - it utilizes the auth service to ensure that the
// user has their auth token before the page loads.
interceptors.start(ApiHttp);

/**
 * Avoids multiple concurrent in-flight GET requests to the same URL.
 *
 * Capture all GET requests, so that when duplicate requests are made, we can just return
 * the original request's promise.
 */
const in_flight_get_requests = new Map();
const _get = ApiHttp.get;


function formatPromise(request) {
    
    return request.then((response)=> {
            // format the response;
            let newResponse = response && response.data ? response.data : {};
            newResponse.request = response.request;
            newResponse.config = response.config;
            return newResponse
        },
        (e)=> {
            // format the error
            // console.log(e)

            let newResponse = e.request && e.request.response ? JSON.parse(e.request.response) : e;
            try {
                newResponse.httpResponse = e.response;
            }catch (e){
                // /dont do anything
            }
            return Promise.reject(newResponse)
        });

}

ApiHttp.get = function (url, _filters, external = false) {
    if (!~url.indexOf(ApiHttp.defaults.baseURL) && !external) {
        url = `${ApiHttp.defaults.baseURL}${url}`
    }
    let key = url;
    var filters = _filters && _filters.filters ? {params: _filters.filters} : _filters;
    if (in_flight_get_requests.has(key)) {
        return in_flight_get_requests.get(key);
    } else {
        let request = _get(url, filters); //fixme should be ...arguments but need to format filters
        in_flight_get_requests.set(key, request);

        request
            .then(() => {
                in_flight_get_requests.clear(key)
            }) //clear in_flight_get_request outside this requests promise change.
            .catch(() => in_flight_get_requests.clear(key));

        return formatPromise(request);
    }
};

ApiHttp.getBaseLink = function (url, _filters, external = false) {
    if (!~url.indexOf(ApiHttp.defaults.baseLinkURL) && !external) {
        url = `${ApiHttp.defaults.baseLinkURL}${url}`
    }
    let key = url;
    var filters = _filters && _filters.filters ? {params: _filters.filters} : _filters;
    if (in_flight_get_requests.has(key)) {
        return in_flight_get_requests.get(key);
    } else {
        let request = _get(url, filters); //fixme should be ...arguments but need to format filters
        in_flight_get_requests.set(key, request);

        request
            .then(() => {
                in_flight_get_requests.clear(key)
            }) //clear in_flight_get_request outside this requests promise change.
            .catch(() => in_flight_get_requests.clear(key));

        return formatPromise(request);
    }
};


const _post = ApiHttp.post;

ApiHttp.post = function (url, _filters, external = false) {
    if (!~url.indexOf(ApiHttp.defaults.baseURL) && !external) {
        url = `${ApiHttp.defaults.baseURL}${url}`
    }

    let request = _post(url, _filters); //fixme should be ...arguments but need to format filters

    return formatPromise(request);
};


const _put = ApiHttp.put;

ApiHttp.put = function (url, _filters, external = false) {
    if (!~url.indexOf(ApiHttp.defaults.baseURL) && !external) {
        url = `${ApiHttp.defaults.baseURL}${url}`
    }
    let request = _put(url, _filters); //fixme should be ...arguments but need to format filters

    return formatPromise(request);
};


const _delete = ApiHttp.delete;

ApiHttp.delete = function (url, _filters, external = false) {
    if (!~url.indexOf(ApiHttp.defaults.baseURL) && !external) {
        url = `${ApiHttp.defaults.baseURL}${url}`
    }

    let request = _delete(url, _filters); //fixme should be ...arguments but need to format filters

    return formatPromise(request);
};


export default ApiHttp;



// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/http/index.js